export default "__VITE_ASSET__DqOYbEPM__"